/**
 * Contenido comercial de 100 NEW YORK COOKIES.
 *
 * Promesa principal: aprender a preparar New York Cookies irresistibles y
 * convertirlas en un producto que se pueda ofrecer desde casa.
 *
 * Regla editorial: no se inventan cifras de compradores, escasez ni promesas
 * de ingresos. Los testimonios de esta maqueta son PLACEHOLDER y están
 * marcados como tales.
 */

export interface Metric {
  value: string;
  label: string;
}
export interface CatalogBlock {
  id: string;
  count: string;
  title: string;
  body: string;
  /** Representación gastronómica de la categoría. */
  image: string;
  alt: string;
}
export interface Flavor {
  id: string;
  name: string;
  tag: string;
  note: string;
  image: string;
  alt: string;
}
export interface Faq {
  question: string;
  answer: string;
}
export interface Bono {
  id: string;
  number: string;
  label: string;
  title: string;
  body: string;
  angle: string;
  image: string;
}

/** PLACEHOLDER TESTIMONIAL — maqueta visual, se reemplaza por reseñas reales. */
export interface PlaceholderTestimonial {
  id: string;
  quote: string;
  name: string;
  country: string;
  /** Iniciales del avatar temporal. No usar fotos de personas inventadas. */
  initials: string;
}
export const PRODUCT_NAME = '100 New York Cookies';
export const PRODUCT_SUBTITLE = 'Aprendé a prepararlas y a ofrecerlas';

/** Precio localizado para Argentina: precio anterior tachado + precio vigente. */
export const PRICE = {
  current: '14.990',
  previous: '29.990',
  currency: "$",
  unit: 'ARS',
  note: 'Pago único · Acceso digital inmediato',
  fx: 'Precio en pesos argentinos (ARS).'
};

/** Ancla de la primera revelación de precio. El CTA del hero scrollea acá. */
export const OFFER_ANCHOR = '#oferta';
export const TICKER_ITEMS: string[] = ['100 RECETAS PASO A PASO', '2 TOMOS DIGITALES', '5 BONOS INCLUIDOS', 'SIN EXPERIENCIA PREVIA', 'ACCESO INMEDIATO'];
export const HERO = {
  eyebrow: '100 recetas paso a paso · Acceso inmediato',
  title: 'Aprendé a preparar New York Cookies irresistibles',
  titleAccent: 'y convertilas en un producto para vender',
  subtitle: 'Descubrí cómo crear un negocio irresistible!!\nPrepará cookies gruesas, rellenas, crocantes por fuera y suaves por dentro, con 100 recetas para crear un catálogo lleno de sabor.',
  note: 'No necesitás experiencia profesional. Seguí las recetas paso a paso y empezá desde tu propia cocina.',
  cta: 'Quiero mis 100 New York Cookies'
};

/** Fila de confianza. Se repite bajo los CTA principales. */
export const TRUST_ITEMS: Array<{
  id: string;
  label: string;
}> = [{
  id: 'pago',
  label: 'Pago seguro'
}, {
  id: 'acceso',
  label: 'Acceso inmediato'
}, {
  id: 'digital',
  label: 'Producto digital'
}, {
  id: 'garantia',
  label: 'Garantía de 7 días'
}];
export const HERO_METRICS: Metric[] = [{
  value: '100',
  label: 'Recetas'
}, {
  value: '2',
  label: 'Tomos digitales'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '24/7',
  label: 'Acceso digital'
}];

/** Sección deseo / oportunidad. */
export const DESIRE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/58f58fcf-19d3-4898-94ca-5b689395f57b.jpg';

/** Elementos gastronómicos decorativos que rompen la grilla con moderación. */
export const DECO_COOKIE = 'https://cdn.magicpatterns.com/patterns/generated-images/10284444-11e4-4549-808f-41618bf95932.jpg';
export const DECO_CRUMBS = 'https://cdn.magicpatterns.com/patterns/generated-images/53319911-89bf-4258-a284-646f951c15fd.jpg';
export const DECO_STACK = 'https://cdn.magicpatterns.com/patterns/generated-images/4c8775ea-6e7b-4b64-b920-8189d0476458.jpg';
export const DESIRE_POINTS: Array<{
  id: string;
  label: string;
}> = [{
  id: 'gruesas',
  label: 'Gruesas y gigantes'
}, {
  id: 'rellenas',
  label: 'Rellenos que se ven'
}, {
  id: 'sabores',
  label: 'Sabores que se piden'
}, {
  id: 'catalogo',
  label: 'Listas para catálogo'
}];

/**
 * FACILIDAD + CONTENIDO, fusionados: 4 beneficios que absorben todo lo que
 * antes estaba repartido entre las dos secciones.
 */
export const EASY_BENEFITS: Array<{
  id: string;
  title: string;
  body: string;
}> = [{
  id: 'paso-a-paso',
  title: '100 recetas explicadas paso a paso',
  body: 'Ingredientes, cantidades y procedimientos claros para avanzar receta por receta, incluso si estás empezando.'
}, {
  id: 'variedad',
  title: 'Cookies gruesas, rellenas y con variedad real',
  body: 'Recetas clásicas, rellenas, premium y combinaciones pensadas para preparar cookies irresistibles y visualmente atractivas.'
}, {
  id: 'catalogo',
  title: 'De 100 recetas a tu propio catálogo',
  body: 'Probá sabores, elegí tus favoritas y armá una variedad de cookies que puedas preparar, mostrar y ofrecer.'
}, {
  id: 'vender',
  title: 'Una base para empezar a vender',
  body: 'Si querés convertir lo que aprendés en un emprendimiento, las recetas te dan variedad suficiente para empezar a construir una propuesta de productos para ofrecer.'
}];

/** PARA QUIÉN ES. */
export const AUDIENCE_CARDS: Array<{
  id: string;
  title: string;
  body: string;
}> = [{
  id: 'principiantes',
  title: 'Principiantes',
  body: 'Para quienes quieren empezar desde cero siguiendo recetas claras.'
}, {
  id: 'emprender',
  title: 'Quienes quieren emprender',
  body: 'Para quienes buscan un producto atractivo que puedan preparar y comenzar a ofrecer desde casa.'
}, {
  id: 'reposteria',
  title: 'Quienes ya hacen repostería',
  body: 'Para ampliar su repertorio con nuevas recetas, sabores y combinaciones.'
}, {
  id: 'venden',
  title: 'Quienes ya venden dulces',
  body: 'Para sumar un producto visualmente atractivo y ampliar su catálogo.'
}, {
  id: 'fanaticos',
  title: 'Fanáticos de las cookies',
  body: 'Para quienes simplemente quieren aprender a preparar New York Cookies increíbles.'
}];
export const CATALOG_BLOCKS: CatalogBlock[] = [{
  id: 'clasicas',
  count: '20',
  title: 'Clásicas y comerciales',
  body: 'Las que gustan siempre. La base de cualquier catálogo de cookies.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/dda2c673-2600-49b5-8db4-1156af17491b.jpg',
  alt: 'Cookie clásica de chocolate chip vista desde arriba.'
}, {
  id: 'rellenas',
  count: '25',
  title: 'Rellenas',
  body: 'Corazón fundente, dulce de leche, cremas y ganaches. Las que enamoran al partirse.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b2a26a64-3e7c-4f96-8739-52177eb110a1.jpg',
  alt: 'Cookie partida al medio con dulce de leche estirándose.'
}, {
  id: 'premium',
  count: '20',
  title: 'Premium y gourmet',
  body: 'Combinaciones de alto valor percibido para las opciones más especiales de tu carta.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d02d8643-4ee5-486e-98a7-f6a3036a24a2.jpg',
  alt: 'Cookie de pistacho abierta con crema verde y pistachos tostados.'
}, {
  id: 'populares',
  count: '20',
  title: 'Sabores populares',
  body: 'Chocotorta, Lemon Pie, Red Velvet, cookies & cream y más clásicos irresistibles.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/072aa39f-4445-4da3-8f30-f07febcaafc2.jpg',
  alt: 'Cookie cookies & cream abierta con crema blanca y trozos de galleta.'
}, {
  id: 'especiales',
  count: '15',
  title: 'Especiales y visuales',
  body: 'Cookies pensadas para la foto, las fechas especiales y las ediciones limitadas.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1bd5dd5c-daa4-4b96-88ef-348f48d7ef33.jpg',
  alt: 'Cookie Red Velvet partida con relleno cremoso blanco.'
}];
export const FLAVORS: Flavor[] = [{
  id: 'dulce-de-leche',
  name: 'Dulce de leche',
  tag: 'Rellena',
  note: 'Corazón de dulce de leche que se estira al partirla.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b2a26a64-3e7c-4f96-8739-52177eb110a1.jpg',
  alt: 'New York Cookie partida al medio con relleno de dulce de leche estirándose.'
}, {
  id: 'pistacho',
  name: 'Pistacho',
  tag: 'Premium',
  note: 'Crema de pistacho y pistachos tostados.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d02d8643-4ee5-486e-98a7-f6a3036a24a2.jpg',
  alt: 'New York Cookie abierta con relleno de crema de pistacho verde y pistachos tostados.'
}, {
  id: 'brownie-fudge',
  name: 'Brownie Fudge',
  tag: 'Chocolate',
  note: 'Doble chocolate con centro fundente de ganache.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/6c999f89-2f9c-41a4-8aab-0812dc5e79ad.jpg',
  alt: 'New York Cookie de doble chocolate partida con ganache fundente cayendo.'
}, {
  id: 'red-velvet',
  name: 'Red Velvet',
  tag: 'Visual',
  note: 'Rojo intenso y relleno de chocolate blanco.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1bd5dd5c-daa4-4b96-88ef-348f48d7ef33.jpg',
  alt: 'New York Cookie Red Velvet partida con relleno cremoso blanco.'
}, {
  id: 'cookies-cream',
  name: 'Cookies & Cream',
  tag: 'Popular',
  note: 'Galleta de chocolate triturada y crema de vainilla.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/072aa39f-4445-4da3-8f30-f07febcaafc2.jpg',
  alt: 'New York Cookie cookies & cream abierta con crema blanca y trozos de galleta.'
}, {
  id: 'lemon-pie',
  name: 'Lemon Pie',
  tag: 'Especial',
  note: 'Curd de limón y merengue tostado arriba.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d5c08300-c18b-43ff-aac1-d526a8324f5e.jpg',
  alt: 'New York Cookie abierta con relleno de curd de limón y merengue tostado.'
}];
export const FLAVOR_PILLS: string[] = ['Chocolate', 'Pistacho', 'Dulce de leche', 'Red Velvet', 'Chocotorta', 'Lemon Pie', 'Brownie Fudge', 'Cinnamon Roll', 'Cookies & Cream', 'Caramelo', 'Frutos rojos', 'Chocolate blanco'];

/** Sección "el relleno" — el momento de mayor deseo de la página. */
export const STUFFED_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/649576e7-f156-451a-8db3-593156a8113a.jpg';
export const STUFFED_POINTS: string[] = ['25 recetas rellenas', 'Rellenos que no se escapan', 'Centros fundentes y cremosos', 'Corte que se ve en la foto'];

/** Qué vas a aprender. */
export const CONTENT_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/08696760-affc-4bdf-a245-ca532d3fb26d.jpg';

/** Pequeños visuales de proceso que acompañan la lista. */
export const CONTENT_TEXTURES: Array<{
  id: string;
  image: string;
  alt: string;
}> = [{
  id: 'masa',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7311c3e3-6c73-425b-b7b5-9a8f6009da4f.jpg',
  alt: 'Bolas de masa cruda de cookie con trozos grandes de chocolate.'
}, {
  id: 'relleno',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/6a358651-d0b6-42c0-851c-856f581ceb69.jpg',
  alt: 'Ganache de chocolate y dulce de leche brillante cayendo de una cuchara.'
}, {
  id: 'terminacion',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7a67f30c-dec6-43b8-a1b8-25327095419a.jpg',
  alt: 'Cookies gruesas envueltas y apiladas, listas para entregar.'
}];

/** De tu cocina a tu propio catálogo. */
export const SELL_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/05a39b88-62de-449e-8703-b00dee8fd975.jpg';
export const SELL_INTRO = 'Aprender a preparar una buena cookie es el primer paso. Si además querés empezar a ofrecerlas, vas a necesitar organizar tus opciones, conseguir mayor consistencia, cuidar la presentación y mostrar tus productos de una manera que genere ganas de probarlos. Por eso este pack no termina en las 100 recetas.';
export const JOURNEY_STEPS: Array<{
  id: string;
  number: string;
  title: string;
  body: string;
  image: string;
  alt: string;
}> = [{
  id: 'aprende',
  number: '01',
  title: 'Aprendé',
  body: 'Elegís una de las 100 recetas y seguís el paso a paso desde el principio.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7311c3e3-6c73-425b-b7b5-9a8f6009da4f.jpg',
  alt: 'Bolas de masa cruda de cookie con trozos grandes de chocolate.'
}, {
  id: 'horquea',
  number: '02',
  title: 'Horneá',
  body: 'Trabajás masa, relleno y punto de cocción para lograr la textura New York.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/08696760-affc-4bdf-a245-ca532d3fb26d.jpg',
  alt: 'Bandeja llena de cookies gruesas recién horneadas con chocolate fundido encima.'
}, {
  id: 'presenta',
  number: '03',
  title: 'Presentá',
  body: 'Definís tamaños, porcionado y terminación para que cada cookie se vea igual de bien.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7a67f30c-dec6-43b8-a1b8-25327095419a.jpg',
  alt: 'Cookies gruesas envueltas y apiladas, listas para entregar.'
}, {
  id: 'catalogo',
  number: '04',
  title: 'Armá tu catálogo',
  body: 'Organizás tus variedades y las descripciones con las que vas a mostrarlas.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/05a39b88-62de-449e-8703-b00dee8fd975.jpg',
  alt: 'Cookies presentadas en cajas de cartón kraft, listas para entregar.'
}, {
  id: 'ofrece',
  number: '05',
  title: 'Empezá a ofrecer',
  body: 'Mostrás tus cookies con fotos que den ganas de probarlas y empezás desde casa.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/4c8775ea-6e7b-4b64-b920-8189d0476458.jpg',
  alt: 'Pila de cookies gruesas de distintos sabores.'
}];

/**
 * Reaparición de los dos tomos, para que se vea la cantidad real de material
 * que se recibe. Los subtítulos son los de las propias tapas.
 */
export const TOMOS = [{
  id: 'tomo-1',
  label: 'Tomo 1',
  title: 'Recetas clásicas, rellenas y sabores irresistibles'
}, {
  id: 'tomo-2',
  label: 'Tomo 2',
  title: 'Sabores especiales, ediciones temáticas y recetas para vender'
}];

/** Los 5 bonos digitales. Portadas y nombres provistos por el cliente. */
export const BONOS: Bono[] = [{
  id: 'bono-1',
  number: '01',
  label: 'Bono #1',
  title: 'Mapa de inicio rápido',
  body: 'Para que no te pierdas entre 100 recetas. Te ayuda a organizar tus primeros pasos, entender por dónde empezar y avanzar de forma más ordenada.',
  angle: 'Pasá de “tengo 100 recetas” a “sé por dónde empezar”.',
  image: 'https://cdn.magicpatterns.com/uploads/irwrNghyZBVBg6e5x1qoMM/bono_1.png'
}, {
  id: 'bono-2',
  number: '02',
  label: 'Bono #2',
  title: 'Checklist anti-fallas',
  body: 'Un recurso práctico para detectar y evitar errores frecuentes antes de que arruinen el resultado.',
  angle: 'Más consistencia = un producto más fácil de repetir y ofrecer.',
  image: 'https://cdn.magicpatterns.com/uploads/6GExUZRYBbqhXpJvshomoJ/bono_2.png'
}, {
  id: 'bono-3',
  number: '03',
  label: 'Bono #3',
  title: 'Guía visual de tamaños, porcionado y formato comercial',
  body: 'Una guía para ayudarte a definir tamaños, porciones y presentaciones más consistentes.',
  angle: 'Dejá de hacer “una cookie diferente cada vez” y empezá a pensar en un producto.',
  image: 'https://cdn.magicpatterns.com/uploads/xkxuEZxYL6N1Zyx5bVjA56/bono_3.png'
}, {
  id: 'bono-4',
  number: '04',
  label: 'Bono #4',
  title: 'Catálogo Express',
  body: 'Un recurso para organizar tus variedades y convertir todas esas recetas en una oferta más clara para mostrar.',
  angle: 'De 100 recetas a un catálogo que podés presentar.',
  image: 'https://cdn.magicpatterns.com/uploads/qDWUXAvmTrvUfcwTbfDYcv/bono_4.png'
}, {
  id: 'bono-5',
  number: '05',
  label: 'Bono #5',
  title: 'Mini guía de fotos caseras para cookies que venden por los ojos',
  body: 'Consejos prácticos para fotografiar tus cookies de una manera más atractiva utilizando recursos accesibles.',
  angle: 'Porque antes de probar una cookie, tu cliente la ve.',
  image: 'https://cdn.magicpatterns.com/uploads/mJzQB5URemQ536cSRjcb2p/bono_5.png'
}];

/**
 * PLACEHOLDER TESTIMONIALS — maqueta visual.
 * No usar en Schema Review, AggregateRating, SEO, metadatos, anuncios ni
 * contadores de clientes. Se reemplazan por testimonios auténticos.
 */
export const PLACEHOLDER_TESTIMONIALS: PlaceholderTestimonial[] = [{
  id: 'ph-1',
  quote: 'Pensé que iba a ser complicado porque nunca había hecho cookies de este estilo. Seguí las recetas paso a paso y me sorprendió muchísimo el resultado. Quedaron gruesas, suaves por dentro y con una pinta increíble.',
  name: 'Camila R.',
  country: 'Chile',
  initials: 'CR'
}, {
  id: 'ph-2',
  quote: 'Quería sumar algo diferente a lo que ya vendía y las New York Cookies me parecieron perfectas. Lo que más me gustó fue tener tantos sabores juntos porque pude elegir cuáles quería incorporar primero a mi catálogo.',
  name: 'Valentina M.',
  country: 'Colombia',
  initials: 'VM'
}, {
  id: 'ph-3',
  quote: 'Empecé sin saber prácticamente nada de este tipo de cookies. Las explicaciones me resultaron fáciles de seguir y ahora tengo un montón de ideas para probar. Las rellenas fueron mis favoritas.',
  name: 'Fernanda L.',
  country: 'México',
  initials: 'FL'
}, {
  id: 'ph-4',
  quote: 'Yo ya hacía postres para vender, pero siempre terminaba ofreciendo lo mismo. Con las recetas encontré sabores y combinaciones nuevas que me dieron muchas ideas para renovar lo que ofrezco.',
  name: 'Daniela P.',
  country: 'Perú',
  initials: 'DP'
}, {
  id: 'ph-5',
  quote: 'Lo compré principalmente porque quería aprender a hacer esas cookies enormes y rellenas que veía en redes. Me encantó que hubiera tanta variedad y que estuviera explicado paso a paso.',
  name: 'Sofía A.',
  country: 'Costa Rica',
  initials: 'SA'
}];

/** Stack completo: lo que entra en el kit. */
export const STACK_HIGHLIGHTS: Array<{
  id: string;
  value: string;
  label: string;
}> = [{
  id: 'recetas',
  value: '100',
  label: 'Recetas'
}, {
  id: 'tomos',
  value: '2',
  label: 'Tomos'
}, {
  id: 'bonos',
  value: '5',
  label: 'Bonos'
}, {
  id: 'acceso',
  value: '24/7',
  label: 'Acceso inmediato'
}, {
  id: 'pago',
  value: '1',
  label: 'Pago único'
}];
export const STACK_COPY = '100 recetas paso a paso + 5 recursos complementarios pensados para ayudarte a preparar, organizar, presentar y comenzar a ofrecer tus cookies.';
export const GUARANTEE = {
  title: 'Probalo con 7 días de garantía',
  body: 'Queremos que puedas revisar el material con tranquilidad. Tu compra cuenta con una garantía de 7 días según las condiciones de la tienda.',
  seal: '7 días'
};

/**
 * Resumen compacto de la caja de oferta.
 */
export const OFFER_SUMMARY: string[] = ['2 tomos digitales', '100 recetas paso a paso', 'Clásicas, rellenas, premium y especiales', 'Fundamentos de masa, relleno y horneado', 'Presentación, porcionado y conservación', '+ 5 bonos digitales de regalo'];
export const FAQS: Faq[] = [{
  question: '¿Necesito experiencia?',
  answer: 'No. Cada receta está pensada para seguirse paso a paso desde casa, con ingredientes, cantidades y procedimientos explicados en orden. Los fundamentos de masa, relleno y horneado te acompañan para que el resultado se repita.'
}, {
  question: '¿Son realmente 100 recetas?',
  answer: 'Sí. Son 100 recetas distribuidas en dos tomos digitales: 20 clásicas y comerciales, 25 rellenas, 20 premium y gourmet, 20 de sabores populares y 15 especiales y visuales.'
}, {
  question: '¿Puedo utilizar las recetas para preparar cookies para vender?',
  answer: 'Sí. El material está pensado para que puedas prepararlas y, si querés, incorporarlas a lo que ofrecés. Tené en cuenta las normas de elaboración y venta de alimentos que correspondan en tu ciudad o país.'
}, {
  question: '¿Es un producto físico?',
  answer: 'No. Es un producto 100% digital: no se envía nada a domicilio.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Al confirmarse la compra obtenés acceso al material digital y podés abrirlo desde el teléfono, la tablet o la computadora.'
}, {
  question: '¿Cuándo recibo el acceso?',
  answer: 'El acceso es inmediato. Una vez confirmado el pago podés abrir los dos tomos y los bonos, y empezar con la primera receta el mismo día.'
}, {
  question: '¿Qué incluyen los 5 bonos?',
  answer: 'Incluyen el Mapa de inicio rápido para ordenar tus primeros pasos, el Checklist anti-fallas para evitar errores frecuentes, la Guía visual de tamaños y porcionado, el Catálogo Express para organizar tus variedades y la Mini guía de fotos caseras para mostrar mejor tus cookies.'
}, {
  question: '¿Tengo garantía?',
  answer: 'Sí. Tu compra cuenta con una garantía de 7 días según las condiciones de la tienda, para que puedas revisar el material con tranquilidad.'
}, {
  question: '¿El pago es único?',
  answer: "Sí. Es un pago único de $14.990 pesos argentinos (antes $29.990) por el acceso a los dos tomos y los cinco bonos. No hay suscripción ni cargos posteriores."
}];
export const NAV_LINKS: Array<{
  label: string;
  href: string;
}> = [{
  label: 'Qué aprendés',
  href: '#aprendes'
}, {
  label: 'Sabores',
  href: '#sabores'
}, {
  label: 'Emprender',
  href: '#vender'
}, {
  label: 'Bonos',
  href: '#bonos'
}, {
  label: 'Preguntas',
  href: '#faq'
}];

/** Contactos reales del footer. Sin placeholders ni links que vuelvan al inicio. */
export const BRAND = {
  studio: 'Creativo Digital',
  email: 'atencion.creativodigital@gmail.com',
  instagramHandle: '@creativodigitalstudio',
  instagramUrl: 'https://www.instagram.com/creativodigitalstudio/',
  siteLabel: 'creativodigital.shop',
  siteUrl: 'https://creativodigital.shop/'
};